'use strict'

import React from 'react';
import priority from '../../app/utils/priority.js';
import riskResponseLabel from './riskResponseLabel.js';
import {RiskTable} from '../Risk.jsx';
import {RiskStatement} from './RiskForm.jsx';
import FormattedContent from '../components/FormattedContent.jsx';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

export default class PresentationView extends React.Component {
  constructor(props) {
    super(props);
    this.state={selected:props.items.filter(item=>item.id===props.selected)[0],
                showClosed:this.props.showClosed};
  }

  render() {
    let reportStyle={textAlign:"left", maxWidth:1016};
    let style=Object.assign({},reportStyle,this.props.settings!==undefined ? this.props.settings.style : undefined);
    return (
      <div>
        {this.props.fullPage!==true ? (
          <div style={{textAlign:"center"}}>
            <div style={{textAlign:"left"}}>
              <PresentationMenu
                {...this.props}
                selected={this.state.selected}
                showClosed={this.state.showClosed}
                onSelect={(item)=>this.setState({selected: item})}
                onShowAll={(event)=>{event.preventDefault(); this.setState({selected:undefined, showClosed:true})}}
                onShowAllOpen={(event)=>{event.preventDefault(); this.setState({selected:undefined, showClosed:false})}}
                onEdit={(event)=>{event.preventDefault();if (this.state.selected!==undefined) this.props.onEdit(this.state.selected)}}
              />
            </div>
          </div>
        ) : null}
        <div style={{display:"inline-block", padding:5, paddingLeft:10, fontFamily: "Verdana, sans-serif", justifyContent:"center"}}>
          <div className="report" style={style}>
            {this.props.items.map(item=>this.state.selected===undefined || item.id===this.state.selected.id  ? (
              this.state.showClosed===false && item.status==="Closed" && this.state.selected===undefined ? null : <PresentRisk key={item.id} {...this.props} item={item}/>
            ) : null)}
          </div>
        </div>
      </div>
    )
  }
}

class PresentRisk extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div style={{paddingBottom:100}}>
        <div style={{fontWeight: "bold", paddingBottom:20}}>
          {this.props.item.title}
        </div>
        <div style={{display:"flex", flexWrap: "wrap"}}>
          {this.props.item.status!=="Closed" ? (
            <div style={{paddingRight:40, paddingBottom:20}}>
              <RiskTable {...this.props} items={[this.props.item]}/>
            </div>
          ) : null }
          <div>
            <div style={{display:"table", borderCollapse:"collapse", border: "solid 1px #f7f7f7", width:"100%"}}>
              <DetailsRow label={labels.identify.fields.owner.title} value={this.props.item.owner}/>
              <DetailsRow label={labels.identify.fields.type.title} value={labels.identify.fields.type.options[this.props.item.type]}/>
              <DetailsRow label={labels.identify.fields.category.title} value={labels.identify.fields.category.options[this.props.item.category]}/>
              <DetailsRow label={labels.assess.fields.proximity.title} value={this.props.item.proximity}/>
              <DetailsRow label={labels.plan.fields.response.title} value={labels.plan.fields.response.options[this.props.item.response]}/>
              <DetailsRow label={labels.plan.fields.actionee.title} value={this.props.item.actionee}/>
              <DetailsRow label={labels.implement.fields.status.title} value={labels.implement.fields.status.options[this.props.item.status]}/>
            </div>
          </div>
        </div>
        <div style={{paddingTop:15}}>
          <b>{labels.general.riskStatement}</b>
          <RiskStatement {...this.props} {...this.props.item} expanded={true}/>
        </div>
        <div style={{paddingTop:15}}>
          <div style={{fontWeight: "bold"}}>{labels.plan.fields.action.title}</div>
          <div style={{display: "flex", alignItems:"center"}}>
            <FormattedContent value={this.props.item.action}/>
            <div style={{paddingLeft: 10}}>(<i>{riskResponseLabel(this.props.item.response,this.props.language)}</i>)</div>
          </div>
        </div>
        <div style={{paddingTop:15}}>
          <div style={{fontWeight: "bold"}}>{labels.implement.fields.comments.title}</div>
          <FormattedContent value={this.props.item.comments}/>
        </div>
        <div style={{position:"relative", pageBreakAfter:"always", pageBreakInside:"avoid"}}></div>
      </div>
    );
  }
}

class DetailsRow extends React.Component {
  render() {
    return (
      <div style={{display:"table-row"}}>
        <div style={{display:"table-cell", padding:5, paddingRight: 20, fontWeight: "bold", border: "solid lightgrey 1px", backgroundColor:"#e9e7e6"}}>{this.props.label}</div>
        <div style={{display:"table-cell", padding:5, paddingRight: 20, border: "solid lightgrey 1px", }}>{this.props.value}</div>
      </div>

    );
  }
}
class PresentationMenu extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).views.present.menu;
    return (
      <div style={{display:"inline-block", float: "right",marginRight: 30, width:250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft:10, paddingBottom: 150}}>
        {this.props.view!=="presentOnly" ? (
          <div>
            <div style={{paddingLeft:10, paddingBottom:20}}>
              <a href="#" onClick={this.props.onShowListView}>&lt;- {labels.backToRiskRegister}</a>
            </div>
            <b>{labels.title}</b>

            <div style={{display:"none", paddingLeft:10}}>
              <a href={"risk?details=presentation"+(this.props.selected!==undefined ? "&selected="+this.props.selected.id : "")+"&fullPage=true"} target="_blank">{labels.viewFullScreen}</a>
            </div>
            <div style={{paddingLeft:10,paddingBottom: 10}}>
              <a href={"risk?details=presentation"+(this.props.selected!==undefined ? "&selected="+this.props.selected.id : "")+"&fullPage=true&pdf=true&showClosed="+this.props.showClosed} target="_blank">{labels.viewPDF}</a>
            </div>

            {this.props.showClosed!==true || this.props.selected!==undefined ?
            (<div style={{paddingLeft:10}}>
                <a href="#" onClick={this.props.onShowAll}>{labels.allRiskItems}</a>
            </div>) : null}

            {this.props.showClosed===true || this.props.selected!==undefined ?
            (<div style={{paddingLeft:10}}>
                <a href="#" onClick={this.props.onShowAllOpen}>Show open risks</a>
            </div>) : null}

            {this.props.selected!==undefined && this.props.selected.readOnly!==true ? (
              <div style={{paddingLeft:10, paddingTop: 10}}>
                <a href="#" onClick={this.props.onEdit}>{labels.editRiskItem}</a>
              </div>
            ) : null}
          </div>
        ) : null}
        <div style={{paddingTop:15}}>
          <div style={{fontWeight:"bold"}}> {labels.selectRiskItem}: </div>
          <RiskList {...this.props}/>
        </div>
      </div>
    );
  }
}

class RiskListEntry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hover: false};
  }

  toggleHover(event) {
    event.preventDefault();
     this.setState({hover: !this.state.hover});
   }

  selectItem() {
    if (this.props.onSelect!==undefined) {
      this.props.onSelect(this.props.item);
    }
  }
  render() {
    var item=this.props.item;
    var bgColor=this.state.hover ? "#f1fbfe" : this.props.backgroundColor;
    return (
      <div
        onClick={this.selectItem.bind(this)}
        onMouseEnter={this.toggleHover.bind(this)}
        onMouseLeave={this.toggleHover.bind(this)}
        style={{
          cursor:"pointer", display:"table-row", textAlign:"left",
          backgroundColor:bgColor,
           borderBottom:"solid 1px #939393",
          color:item.status==="Closed" ? "lightgrey" : "#212121",
          textDecoration:item.status==="Closed" ? "line-through" : "none"}
        }
      >
        <div style={{paddingTop:2, paddingLeft:1, paddingRight:5}}>
                  <div style={{display:"table-cell,inline-block",marginTop:4, padding:8, borderRadius:"50%", width:0, hight:15, backgroundColor:priority.priorityColor(item,this.props.profile) }}> </div>
        </div>
        <div style={{display:"table-cell", fontWeight: "normal", textAlign:"center", padding:5}}>
          {item.no}
        </div>
        <div style={{display:"table-cell", padding:5}}>
          {item.title}
        </div>
      </div>
    );
  }
}

class RiskList extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    var selectItem=this.props.onSelect;
    return (
      <div>
        <div style={{display:"table", width:"100%", borderCollapse:"collapse", borderBottom:"solid 1px #939393"}}>
          <div style={{display: "table-row", pageBreakInside:"avoid", backgroundColor:"#ffffff",color:"#ffffff", fontWeight:"bold", textAlign:"left"}}>
            <div style={{display:"table-cell", paddingTop:5, paddingBottom:5, paddingLeft:5, pageBreakInside:"avoid"}}></div>
            <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}></div>
            <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}></div>
          </div>
          {this.props.items.map((item,index)=>(
            <RiskListEntry
              key={item.id}
              {...this.props}
              item={item}
              onSelect={selectItem}
              backgroundColor={this.props.selected!==undefined && item.id===this.props.selected.id ? "#d4e9f2": index%2===1 ? "#f7f7f7" : "white"}
            />
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/risk/PresentationView.jsx